import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer style={styles.footer}>

            <p style={styles.footerText}>
                NGEN ART, Co. Owned and Operated by Peter Cybriwsky
            </p>
            <p style={styles.footerText}>
                Email: <a href="mailto:pete@ngenart.com" style={styles.footerLink}>pete@ngenart.com</a>
            </p>

            <p style={styles.text}>
                App and site made with ♥️ by{' '}
                <a
                    href="https://instagram.com/_re_pete"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={styles.link}
                >
                    Pete
                </a>
            </p>
        </footer>
    );
}

const styles = {
    footer: {
        padding: '2rem',
        textAlign: 'center',
        fontFamily: '"Bodoni Moda", serif',
        borderTop: '1px solid rgba(0,0,0,0.1)',
        backgroundColor: '#fffef7',
    },
    text: {
        color: '#0a0a0a',
        fontSize: '1rem',
    },
    link: {
        color: '#0a0a0a',
        textDecoration: 'none',
        borderBottom: '1px solid #0a0a0a',
        transition: 'opacity 0.2s ease',
        ':hover': {
            opacity: 0.7,
        },
    },
};

export default Footer;